import React from "react";
import { adminApi as api } from "../../../util/api";
import { snakifyKeys } from "../../../util/helpers";
import { ImportModal } from "../../components/ImportModal";

export const ImportCaseTypeCptMappingModal = ({ labId, onImport, ...rest }) => {
  const handleImport = async (values) => {
    const params = {
      labId: values.labId,
      file: {
        bytes: values.file,
      },
    };

    const res = await api.post(`/admin/case_type_test_mappings/background_import.json?lab_id=${labId}`, snakifyKeys(params));

    if (onImport) {
      onImport(res.data?.meta?.message);
    }
  };

  return (
    <ImportModal
      buttonProps={rest}
      onImport={handleImport}
      title="Import Case Type CPT Code Override..."
      exampleDownloadPath="/admin/case_type_test_mappings/example"
    ></ImportModal>
  );
};
